export default __webpack_public_path__ + "static/media/Allround.af8af9a6.svg";